import {Game} from "../Game";
import {Config} from "../config/Config";
import {Mental2SymbolStates, SYMBOL} from "../enums/Enum";
import {GameUtils} from "../utils/GameUtils";
import {DeadMultiplier} from "../components/DeadMultiplier";

export class Symbol extends PIXI.spine.Spine {
    protected _currentHeight: number = 198;
    protected _symbolName: string;
    protected _index: number;
    private _deadMultiplier: DeadMultiplier | undefined;

    constructor(symbolName: string, initState: Mental2SymbolStates, index: number) {
        super(Game.assetLoader.getSpineAsset(symbolName));
        this.init(symbolName, initState, index);
    }

    public init(symbolName: string, initState: Mental2SymbolStates, index: number): void {
        this._index = index;
        this._symbolName = symbolName;
        this.name = this._symbolName + "_" + this._index;
        this.visible = true;
        this.setState(initState);
    }

    public getMultiplier(): number {
        let multiplier: number = 0;
        if (this._deadMultiplier) {
            multiplier = this._deadMultiplier.value;
        }
        return multiplier;
    }

    public setState(state: Mental2SymbolStates): PIXI.spine.core.TrackEntry | undefined {
        let animString: string = GameUtils.animStringByState(state);
        switch (state) {
            case Mental2SymbolStates.STANDARD_FS_ANTICIPATION:
                this.tint = 0x666666;
                break;
            case Mental2SymbolStates.COOL_FS_ANTICIPATION:
                this.tint = 0x444444;
                break;
            case Mental2SymbolStates.SUPER_FS_ANTICIPATION:
                this.tint = 0x222222;
                break;
            case Mental2SymbolStates.NO_WIN:
                this.tint = 0x777676;
                if (this._deadMultiplier) {
                    this._deadMultiplier.enable = false;
                }
                break;
            case Mental2SymbolStates.NORMAL:
                this.tint = 0xffffff;
                if (this._deadMultiplier) {
                    this._deadMultiplier.enable = true;
                }
                break;
            default:
                return this.setResizeState(animString);
        }
    }

    public setStateAsPerParts(parts: number, currentHeight ?: number): PIXI.spine.core.TrackEntry | undefined {
        const height: number = currentHeight || (198 / parts),
            actualHeight: number = Config.AVAILABLE_SYMBOL_SIZES.reduce((prev: number, curr: number) => {
                return (Math.abs(curr - height) < Math.abs(prev - height) ? curr : prev);
            });
        if (actualHeight !== height) {
            this.scale.y = height / actualHeight;
        }
        this._currentHeight = height;
        return this.setState(GameUtils.getReSizeState(actualHeight));
    }

    public clearAnimations(): void {
        this.visible = false;
        this.position.set(0);
        this.pivot.set(0);
        this.scale.set(1);
        this.alpha = 1;
        this.skeleton.setSlotsToSetupPose();
        this.skeleton.setToSetupPose();
        this.state.clearTracks();
        this.state.setEmptyAnimation(0, 0);
        this.tint = 0xffffff;
        if (this._deadMultiplier) {
            this._deadMultiplier.destroy();
            this._deadMultiplier = undefined;
        }
    }

    public addDeadMultiplier(multiplier: number): void {
        if (this._deadMultiplier) {
            console.warn("already have multiplier");
            this._deadMultiplier.destroy();
            this._deadMultiplier = undefined;
        }
        this._deadMultiplier = new DeadMultiplier(multiplier);
        if (this.currentHeight < this._deadMultiplier.height) {
            const scale : number = this.currentHeight / this._deadMultiplier.height;
            this._deadMultiplier.scale.set(scale);
        }
        this._deadMultiplier.position.set(Config.SYMBOL_WIDTH * 0.5, this.currentHeight * 0.5 - this._deadMultiplier.height); //#430
        this.addChild(this._deadMultiplier);
    }

    public onResize(): void {
        if (this._deadMultiplier) {
            if (this.currentHeight < this._deadMultiplier.height) {
                const scale : number = this.currentHeight / this._deadMultiplier.height;
                this._deadMultiplier.scale.set(scale);
            }
            this._deadMultiplier.position.set(Config.SYMBOL_WIDTH * 0.5, this.currentHeight * 0.5 - this._deadMultiplier.height); //#430
        }
    }

    public removeSymbol(): void {
        this.clearAnimations();
        if (this._symbolName === SYMBOL.GOD) {

        } else if (this._symbolName === SYMBOL.X_MENTAL) {

        } else if (this._symbolName.includes("TS")) {

        } else {
            Game.graphicsPool.getSymbolPool(this.symbolName).deposit(this);
        }

    }

    public setResizeState(animName: string, loop: boolean = false): PIXI.spine.core.TrackEntry {
        const initStateAnim: PIXI.spine.core.TrackEntry = this.state.setAnimation(0, animName, loop);
        return initStateAnim;
    }

    get currentHeight(): number {
        return this._currentHeight;
    }

    set currentHeight(value: number) {
        this._currentHeight = value;
    }

    get symbolName(): string {
        return this._symbolName;
    }

    set symbolName(value: string) {
        this._symbolName = value;
    }

    get index(): number {
        return this._index;
    }

    set index(value: number) {
        this._index = value;
    }

}